import { i18n } from "../../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import adminRoutes from '../../routes/adminRoutes'
import subscriberApi, { SubscriberCreateRequest } from '../../apis/subscriber.api'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import Card from '../../components/Card'
import Row from '../../components/Row/Row'
import InputText from '../../components/InputText'
import CardButton from '../../components/CardButton'
import InputFile from '../../components/InputFile'
import PageHeading from '../../components/PageHeading'

interface SubscriberCreateProps extends RouteComponentProps {}

interface SubscriberCreateState {
  name: string
  logo: File | null
  logoFilename: string
  address: string
  city: string
  state: string
  zip: string
}

class SubscriberCreate
  extends Component<SubscriberCreateProps, SubscriberCreateState> {
  constructor (props: SubscriberCreateProps) {
    super(props)
    this.state = {
      name: '',
      logo: null,
      logoFilename: '',
      address: '',
      city: '',
      state: '',
      zip: ''
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleFileChange = this.handleFileChange.bind(this)
    this.handleCreateClick = this.handleCreateClick.bind(this)
  }

  create () {
    const { name, logo, address, city, state, zip } = this.state
    const payload: SubscriberCreateRequest = {}
    if (name) payload.name = name
    if (logo) payload.logo = logo
    if (address) payload.address = address
    if (city) payload.city = city
    if (state) payload.state = state
    if (zip) payload.zip = zip
    subscriberApi.create(payload, subscriber => {
      if (!subscriber) return
      this.props.history.push(adminRoutes.subscribers)
    })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'name') this.setState({ name: value })
    else if (name === 'address') this.setState({ address: value })
    else if (name === 'city') this.setState({ city: value })
    else if (name === 'state') this.setState({ state: value })
    else if (name === 'zip') this.setState({ zip: value })
  }

  handleFileChange (name: string, file: File | null, filename: string) {
    if (name === 'logo') {
      this.setState({ logo: file, logoFilename: filename })
    }
  }

  handleCreateClick () {
    this.create()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <Card>
            <PageHeading text={i18n("Create Subscriber")} />
            <Row column={2}>
              <InputText
                name="name"
                value={this.state.name}
                label={i18n("Name")}
                onChange={this.handleInputChange} />
              <InputFile
                name="logo"
                filename={this.state.logoFilename}
                accept="image/*"
                label="Logo"
                onChange={this.handleFileChange} />
              <InputText
                name="address"
                value={this.state.address}
                label={i18n("Address")}
                onChange={this.handleInputChange} />
              <InputText
                name="city"
                value={this.state.city}
                label={i18n("City")}
                onChange={this.handleInputChange} />
              <InputText
                name="state"
                value={this.state.state}
                label={i18n("State")}
                onChange={this.handleInputChange} />
              <InputText
                name="zip"
                value={this.state.zip}
                label={i18n("Zip")}
                onChange={this.handleInputChange} />
            </Row>
            <CardButton
              proceedText={i18n("Create")}
              cancelText={i18n("Cancel")}
              onProceedClick={this.handleCreateClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(SubscriberCreate)
